import { render } from "./Cookie.vue?vue&type=template&id=31d80f02"
import script from "./Cookie.vue?vue&type=script&lang=js"
export * from "./Cookie.vue?vue&type=script&lang=js"

import exportComponent from "C:\\DEVER\\meta-buysell.vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__